import React from "react";
import MultiLineDiv from "../MultiLineDiv/MultiLineDiv";
import { getContentItemMetadata, withAuthorization, Analytics, getFullUrl } from "../../utilities";
import ProgressBar from "../ProgressBar/ProgressBar";
import { PlayImage, ReactImage } from "../ReactImage";
import "./Tile.scss";
import { withStore } from "../../store";
import Link from "../Link/Link";

const AuthorizedMultiLineDiv = withAuthorization(MultiLineDiv);

const Tile: React.FunctionComponent<any> = ({ store, contentItem, ...props }) => {
  const { type = -1, tile: { image={} }={},name } = contentItem;
  const { header, meta1, meta2, url } = getContentItemMetadata(contentItem, "Tile");
  const {
    containerTitle,
    containerType,
    position,
    enableAbroadBanner,
    groupName,
    groupItemCount,
    itemPosition,
    groupPosition,
    searchQuery,
    resultsCount
  } = props;

  let progress;
  const reportSelection = () => {
    console.log("__typename =>", type);
    const whitelist = ["Episode", "video", "season", "series"];
    if (whitelist.includes(type)) {
      enableAbroadBanner();
      console.log("Enabled banner component !!!");
    }else{
      console.log("__typename not Episode !!!", type)
    }
    switch(containerType) {
      case "carousel":
      case "grid":
        Analytics.userActionSelectContentFromRail(
          containerTitle,
          position,
          getFullUrl(url),
          header || name,
          {
            item_name: header || name,
            group_name: groupName || "",
            group_item_count: groupItemCount || "",
            item_position: itemPosition || "",
            group_position: groupPosition || ""
          }
        );
        break;
      case "searchResult":
        Analytics.userActionSelectContentFromRail(
          "search_result",
          null,
          getFullUrl(url),
          searchQuery,
          {
            item_name: name,
            item_position: itemPosition || "",
            results_count: resultsCount
          }
        );
        break;
      default:
        break;
    }
  };
  if (contentItem.video_id) {
    progress = ((window.positionData?.[contentItem.video_id] || 0) / contentItem.duration);
  }
  return (
    <div className="Tile">
      <div className="Tile__image">
        {
          type === "Episode" || type === "video" ?
          <PlayImage src={image && image.url} contentItem={contentItem} onClick={reportSelection}/> :

          <Link to={url!} disabled={store.isAbroad} onClick={reportSelection}>
            <ReactImage src={image && image.url} />
          </Link>

        }
        { (progress !== null && progress > 0) && <ProgressBar progress={progress} /> }
      </div>
      {
      type === "Episode" || type === "video" ?
        <AuthorizedMultiLineDiv
          contentItem={contentItem}
          className="Tile__header episode"
          maxLines={3}
          onClick={reportSelection}
        >
          {header}
        </AuthorizedMultiLineDiv> :

        <Link to={url!} disabled={store.isAbroad} onClick={reportSelection}>
          <MultiLineDiv className="Tile__header" maxLines={3}>{header}</MultiLineDiv>
        </Link>
      }
      <div className="Tile__meta1">{meta1}</div>
      <div className="Tile__meta2">{meta2}</div>
    </div>
  )
}

export default withStore(Tile);
